export const additionalChargesTab = {
  loading: "Cargando configuración…",
  tax: {
    title: "Impuesto (IVA)",
    tag: "Incluido en el precio",
    description:
      "El IVA ya está <b>incluido</b> en el precio de tus tarifas. Aquí solo indicas qué porcentaje se desglosa en el recibo y la factura — <b>no se suma al total</b>.",
    hint: "Vacío = se usa el IVA del emisor de facturación asignado. Aplica solo a reservas directas.",
  },
  cleaning: {
    title: "Gastos de limpieza",
    tag: "Fijo",
    description: "Importe fijo por estancia. Si es <b>0</b>, no se aplica.",
    showToGuest: "Mostrar en el resumen de la reserva",
  },
  charges: {
    title: "Cargos adicionales",
    summary: "{count} cargo configurado. | {count} cargos configurados.",
    summaryEmpty: "Crea cargos opcionales (por reserva, por persona o por noche).",
    addButton: "Agregar cargo",
    empty: "Aún no hay cargos adicionales.",
    headers: {
      title: "Título",
      method: "Cómo se cobra",
      value: "Valor",
      visible: "Visible",
    },
    titlePlaceholder: "Ej: Tasa turística",
    removeTitle: "Eliminar",
    hint: "Los cargos visibles se muestran como línea separada al huésped en el checkout; los demás se suman al total.",
  },
  methods: {
    perStay: "Importe por reserva",
    perNight: "Importe por noche",
    perPerson: "Importe por persona",
    perPersonPerNight: "Importe por persona y noche",
    percent: "% del total de la reserva",
  },
  validation: {
    cleaningInvalid: "El importe de limpieza debe ser un número válido y positivo.",
    taxRange: "El IVA debe estar entre 0 y 100%.",
    chargeTitleRequired: "Cada cargo adicional necesita un título.",
    chargeValueInvalid: 'El valor del cargo "{title}" no es válido.',
    chargePercentMax: 'El porcentaje del cargo "{title}" no puede superar 100%.',
  },
  toasts: {
    saveSuccess: "Cargos adicionales guardados correctamente.",
    saveError: "No se pudieron guardar los cargos adicionales.",
  },
};
